
(function( ){

//------------------------------------------------------------------------------------------------------------------------------

Tween = function( target , tweenObj , evtObj , id )
{
	var _this = this ;

	if( !tweenObj.time && !tweenObj.delay )
	{
		delete tweenObj.time ;
		delete tweenObj.transition ;
		delete tweenObj.delay ;
		Tween.setParams( target , tweenObj ) ;

		if( evtObj && evtObj.onComplete )   evtObj.onComplete.apply( target , [null] ) ;
		
		return ;
	}

	//   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -

	Tween.running[ Tween.running.length ] = _this ;

	_this.id = id ;
	_this.target = target ;
	_this.enabled = true ;

	_this.startTime = Tween.currentTime ;
	_this.time = tweenObj.time * 1000 ;
	_this.transition = Easing[ tweenObj.transition ] ;
	if( tweenObj.delay ) _this.startTime += tweenObj.delay * 1000 ;

	_this.evtObj = evtObj ;

	_this.tweens = [] ;

	for( paramName in tweenObj )
	{
		if( !paramName.match( Tween.PARAMS_REG ) && target[paramName] != undefined )
		{
			_this.tweens[ _this.tweens.length ] = [ paramName ] ;
		}
	}
	
	//   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -

	if( _this.evtObj )
	{
		_this.evtObj.onStartParams = !_this.evtObj.onStartParams ? [null] : _this.evtObj.onStartParams ;
		_this.evtObj.onUpdateParams = !_this.evtObj.onUpdateParams ? [null] : _this.evtObj.onUpdateParams ;
		_this.evtObj.onCompleteParams = !_this.evtObj.onCompleteParams ? [null] : _this.evtObj.onCompleteParams ;
	}

	//   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -

	var paramName ;
	var def ;
	var value ;
	var unit ;

	_this.isInited = false ;

	//   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -

	_this.update = function( )
	{
		var updateTime = Tween.currentTime - _this.startTime ;

		if( updateTime < 0 )       return ;
		if( updateTime > _this.time )    updateTime = _this.time ;

		//       -       -       -       -       -       -       -       -       -

		if( _this.evtObj )
		{
			if( _this.evtObj.onStart )
			{
				_this.evtObj.onStart.apply( target , _this.evtObj.onStartParams ) ;
				_this.evtObj.onStart = null ;
			} 
		}

		//       -       -       -       -       -       -       -       -       -

		var i ;

		var tw ;
		var name ;
		var def ;
		var value ;
		var unit ;

		if( !_this.isInited )
		{
			//   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -

			if( !tweenObj.time )
			{
				delete tweenObj.time ;
				delete tweenObj.transition ;
				delete tweenObj.delay ;
				Tween.setParams( target , tweenObj ) ;
				_this.destroy( ) ;
				return ;
			}

			//   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -

			for( i in _this.tweens )
			{
				name = _this.tweens[i][0]

				def = Number( String( _this.target[name] ).replace( Tween.UNIT_REG , "" ) ) ;
				value = Number( String( tweenObj[name] ).replace( Tween.UNIT_REG , "" ) ) ;
				unit = String( tweenObj[name] ).replace( Tween.NUM_REG , "" ) ;

				_this.tweens[ i ][1] = def ;
				_this.tweens[ i ][2] = value-def ;
				_this.tweens[ i ][3] = unit ;
			}

			_this.isInited = true ;
		}
		
		//       -       -       -       -       -       -       -       -       -
		// tweens
		// [ name , defaultValue , changeValue , unit ]
		
		var apply ;

		for( i in _this.tweens )
		{
			tw = _this.tweens[i] ;  

			name = tw[0] ;
			def = tw[1] ;
			value = tw[2] ;
			unit = tw[3] ;

			apply = _this.transition( null , updateTime , def , value , _this.time ) ;
			target[ name ] = unit == "" ? apply : apply + unit ;
		}

		//       -       -       -       -       -       -       -       -       -

		if( _this.evtObj )
		{
			if( _this.evtObj.onUpdate )
			{
				_this.evtObj.onUpdate.apply( target , _this.evtObj.onUpdateParams ) ;
			}

			if( updateTime == _this.time && _this.evtObj.onComplete )
			{
				_this.evtObj.onComplete.apply( target , _this.evtObj.onCompleteParams ) ;
			}
		}

		//       -       -       -       -       -       -       -       -       -

		if( updateTime == _this.time )   _this.destroy( ) ;
	}

	//   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -

	_this.removeTween = function( paramName )
	{
		for( var i = 0 ; i < _this.tweens.length ; i++ )
		{
			if( _this.tweens[i][0] == paramName )
			{
				_this.tweens.splice( i , 1 ) ;   
				i-- ;
			}
		}

		if( _this.tweens.length == 0 )    _this.destroy( ) ;
	}

	//   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -

	_this.isDestroy = false ;
	_this.destroy = function( )
	{
		_this.isDestroy = true ;
		// Tween.Array.out( Tween.running , _this ) ;
	}
} ;

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

Tween.NUM_REG = new RegExp( "[0-9.-]\d*" , "g" ) ;
Tween.UNIT_REG = new RegExp( "px|%" , "gi" ) ;
Tween.PARAMS_REG = new RegExp( "^time|^transition|^delay" , "gi" ) ;

Tween.FPS = 1000 / 45 ;

Tween.add = function( target , tweenObj , evtObj , id )
{
	new Tween( target , tweenObj , evtObj , id ) ;  
}
Tween.add.update = function( target , tweenObj , evtObj , id )
{
	Tween.remove( target ) ;
	new Tween( target , tweenObj , evtObj , id ) ;  
}

Tween.startTime = ( new Date( ) ).getTime( ) ;
Tween.currentTime = 0 ;
Tween.running = [] ;

Tween.remove = function( target )
{
	var arr = Tween.running ;
	var length = arr.length ;
	var check ;
	var i ;

	for( i = 0 ; i < length ; i++ )
	{
		check = arr[ i ] ;
		if( check["target"] == target )
		{
			check.enabled = false ;
			check.destroy( ) ;
		}
	}

	return arr ;
}
Tween.remove.byId = function( id )
{
	Tween.Array.out.param( Tween.running , "id" , id ) ;
}
Tween.remove.byParamName = function( target , paramName )
{
	var arr = Tween.Array.getHasSameParam( Tween.running , "target" , target ) ;  

	for( var i in arr ) arr[i].removeTween( paramName ) ;
}

Tween.isTweening = function( target )
{
	return Tween.Array.getHasSameParam( Tween.running , "target" , target ).length != 0 ;
}

//   -   -   -   -   -   -   -   -   -   -   -   -   -

Tween.FPS = 1000 / 60 ;
window.requestAnimationFrame =  window.requestAnimationFrame ||
								window.webkitRequestAnimationFrame ||
								window.mozRequestAnimationFrame ||
								window.oRequestAnimationFrame ||
								window.msRequestAnimationFrame || 
								function( func )
								{
									return setTimeout( func , Tween.FPS ) ;
								} ;

//

Tween.updateRequestID = "" ;
Tween.update = function( )
{
	window.requestAnimationFrame( Tween.update ) ;

	Tween.currentTime = ( new Date( ) ).getTime( ) - Tween.startTime ;

	if( !Tween.running.length )   return ;

	var i ;
	var temp ;
	var length = Tween.running.length ;
	for( i = 0 ; i < length ; i++ )
	{
		temp = Tween.running[i] ;
		if( temp.enabled ) temp.update( ) ;
		if( temp.isDestroy )
		{
			Tween.Array.out( Tween.running , temp ) ;
			length -- ;
			i -- ;
		}
	}
}
Tween.update( ) ;

//   -   -   -   -   -   -   -   -   -   -   -   -   -

//------------------------------------------------------------------------------------------------------------------------------

Tween.add.gpu = function( style , target , tweenObj , evtObj , id )
{
	var originEvtObj = evtObj ;

	evtObj = 
	{
		onStart:function( )
		{
			style.transform = "translate3d(0px, 0px, 0px)" ;
			style.MozTransform = style.OTransform = style.msTransform = style.webkitTransform = style.transform ;  

			if( originEvtObj && originEvtObj.onStart )    originEvtObj.onStart.apply( target , originEvtObj.onStartParams ) ;
		} ,

		onComplete:function( )
		{
			style.transform = "" ;
			style.MozTransform = style.OTransform = style.msTransform = style.webkitTransform = style.transform ;  

			if( originEvtObj && originEvtObj.onComplete )   originEvtObj.onComplete.apply( target , originEvtObj.onCompleteParams ) ;
		}
	}

	if( originEvtObj && originEvtObj.onUpdate )     evtObj.onUpdate = originEvtObj.onUpdate ;
	if( originEvtObj && originEvtObj.onUpdateParams )   evtObj.onUpdateParams = originEvtObj.onUpdateParams ;
	
	Tween.add( target , tweenObj , evtObj , id ) ;
}

//------------------------------------------------------------------------------------------------------------------------------

Tween.autoPause = function( )
{
	Tween.leaveTime = -1 ;

	Tween.onWindow = function( evt )
	{
		switch( evt.type )
		{
			case "focus" :
				if( Tween.leaveTime == -1 ) return ;
				Tween.startTime += ( new Date( ) ).getTime( ) - Tween.leaveTime ;
				Tween.leaveTime = -1 ;
				break ;

			case "blur" :
				Tween.leaveTime = ( new Date( ) ).getTime( ) ;
				break ;
		}
	}
	Tween.Event.add( window , "focus" , Tween.onWindow ) ;
	Tween.Event.add( window , "blur" , Tween.onWindow ) ;
}

//------------------------------------------------------------------------------------------------------------------------------

Tween.scroll = function( value , time , transition , delay , evtObj )
{
	time = time == undefined ? 1 : time ;
	transition = transition == undefined ? "easeInOutCubic" : transition ;
	delay = delay == undefined ? 0 : delay ;
	evtObj = evtObj == undefined ? { } : evtObj ;
	evtObj.onUpdate = Tween.scroll.set ;
	evtObj.onStart = Tween.scroll.onStart ;

	Tween.remove( Tween.scroll ) ;

	Tween.add( Tween.scroll , { pos:value , time:time , transition:transition , delay:delay , id:Tween.scroll.id } , evtObj ) ;
}
Tween.scroll.pos = 0 ;
Tween.scroll.id = "TWEEN_SCROLL" ;
Tween.scroll.set = function( )
{
	window.scrollTo( window.pageXOffset || document.documentElement.scrollLeft , Math.round(Tween.scroll.pos) ) ;
}
Tween.scroll.onStart = function( )
{
	Tween.scroll.pos = window.pageYOffset || document.documentElement.scrollTop ;
	Tween.scroll.set( ) ;
}

//------------------------------------------------------------------------------------------------------------------------------

Call = function( target , callObj , evtObj , id )
{
	var _this = this ;
	Tween.running[ Tween.running.length ] = _this ;

	_this.id = id ;
	_this.target = target ;

	_this.startTime = Tween.currentTime ;
	_this.time = callObj.time * 1000 ;
	_this.count = callObj.count == undefined ? 1 : callObj.count ;
	_this.totalCount = _this.count ;
	if( callObj.delay ) _this.startTime += callObj.delay * 1000 ;

	_this.evtObj = evtObj ;
	_this.enabled = true ;

	//   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -

	if( _this.evtObj )
	{
		_this.evtObj.onStartParams = !_this.evtObj.onStartParams ? [null] : _this.evtObj.onStartParams ;
		_this.evtObj.onCountParams = !_this.evtObj.onCountParams ? [null] : _this.evtObj.onCountParams ;
		_this.evtObj.onUpdateParams = !_this.evtObj.onUpdateParams ? [null] : _this.evtObj.onUpdateParams ;
		_this.evtObj.onCompleteParams = !_this.evtObj.onCompleteParams ? [null] : _this.evtObj.onCompleteParams ;
	}

	_this.evtObj.onCountParams.push( _this.totalCount ) ;

	//   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -

	_this.update = function( )
	{
		var updateTime = Tween.currentTime - _this.startTime ;

		//       -       -       -       -       -       -       -       -       -

		if( updateTime < 0 )       return ;

		if( _this.evtObj.onUpdate )
		{
			_this.evtObj.onUpdate.apply( target , _this.evtObj.onUpdateParams ) ;
		}

		//       -       -       -       -       -       -       -       -       -

		if( _this.evtObj.onStart )
		{
			_this.evtObj.onStart.apply( target , _this.evtObj.onStartParams ) ;
			_this.evtObj.onStart = null ;

			if( _this.evtObj.onCount )
			{
				_this.evtObj.onCountParams[_this.evtObj.onCountParams.length-1] = _this.totalCount-_this.count ;
				_this.evtObj.onCount.apply( target , _this.evtObj.onCountParams ) ;
				_this.startTime += _this.time ;
				_this.count -- ;
				return ;
			}
		}

		//       -       -       -       -       -       -       -       -       -

		if( updateTime < _this.time )    return ;
		
		if( _this.evtObj.onCount )
		{
			_this.evtObj.onCountParams[_this.evtObj.onCountParams.length-1] = _this.totalCount-_this.count ;
			_this.evtObj.onCount.apply( target , _this.evtObj.onCountParams ) ;
		}

		_this.startTime += _this.time ;
		_this.count -- ;

		if( _this.count == 0 )
		{
			if( _this.evtObj.onComplete ) _this.evtObj.onComplete.apply( target , _this.evtObj.onCompleteParams ) ;

			_this.destroy( ) ;
			return ;
		}
	}

	//   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -

	_this.isDestroy = false ;
	_this.destroy = function( )
	{
		_this.isDestroy = true ;
		// Tween.Array.out( Tween.running , _this ) ;
	}
}

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

Call.add = function( target , callObj , evtObj , id )
{
	new Call( target , callObj , evtObj , id ) ;  
}
Call.add.update = function( target , callObj , evtObj , id )
{
	Call.remove( target ) ;
	new Call( target , callObj , evtObj , id ) ;
}

Call.remove = Tween.remove ;

//------------------------------------------------------------------------------------------------------------------------------


	Tween.Array = {} ;
	Tween.Array.out = function( arr , target )
	{
		var length = arr.length ;
		var check ;
		var i ;

		for( i = 0 ; i < length ; i++ )
		{
			check = arr[ i ] ;
			if( check == target )
			{
				arr.splice( i , 1 ) ;
				i -- ;
				length -- ;
			}
		}

		return arr ;
	}

	//

	Tween.Array.out.param = function( arr , paramName , value )
	{
		var length = arr.length ;
		var check ;
		var i ;

		for( i = 0 ; i < length ; i++ )
		{
			check = arr[ i ] ;
			if( check[paramName] == value )
			{
				arr.splice( i , 1 ) ;
				i -- ;
				length -- ;
			}
		}

		return arr ;
	}

	//

	Tween.Array.getHasSameParam = function( arr , paramName , value )
	{
		var length = arr.length ;
		var check ;
		var i ;
		var arr_return = [ ] ;

		for( i = 0 ; i < length ; i++ )
		{
			check = arr[ i ] ;
			if( check[paramName] == value )
			{
				arr_return[ arr_return.length ] = arr[ i ] ;
			}
		}

		return arr_return ;
	}


	Tween.setParams = function( target , initObj , execution )
	{
		if( target instanceof Array )
		{
			for( var i in target )		Utils.setParams( target[i] , initObj ) ;	
			return ;
		}

		//    -    -    -    -    -    -    -    -    -

		if( target && initObj )
		{
			for( var paramStr in initObj )
			{
				if( execution || String( target[paramStr] ) != "undefined" )
				{
					if( initObj[paramStr] instanceof Function )
					{
						target[paramStr] = initObj[paramStr] ;
					}	
					else if( initObj[paramStr] instanceof Object )
					{
						Utils.setParams( target[paramStr] , initObj[paramStr] ) ;
					}
					else
					{
						target[paramStr] = initObj[paramStr] ;
					}
				}
			}
		}
	}


// -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -


/*
 * jQuery Easing v1.3 - http://gsgd.co.uk/sandbox/jquery/easing/
 *
 * Uses the built in easing capabilities added In jQuery 1.1
 * to offer multiple easing options
 *
 * TERMS OF USE - jQuery Easing
 * 
 * Open source under the BSD License. 
 * 
 * Copyright (c) 2008 George McGinley Smith
 * All rights reserved.
*/

/*
 * TERMS OF USE - EASING EQUATIONS
 * 
 * Open source under the BSD License. 
 * 
 * Copyright (c) 2001 Robert Penner
 * All rights reserved.
 */

Easing = 
{
	linear:function(x, t, b, c, d) {
		return c*(t/d) + b;
	},

	easeInQuad: function (x, t, b, c, d) {
		return c*(t/=d)*t + b;
	},
	easeOutQuad: function (x, t, b, c, d) {
		return -c *(t/=d)*(t-2) + b;
	},
	easeInOutQuad: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return c/2*t*t + b;
		return -c/2 * ((--t)*(t-2) - 1) + b;
	},
	easeOutInQuad: function (x, t, b, c, d) {
		if (t < d/2) return Easing.easeOutQuad(x,t*2, b, c/2, d);
		return Easing.easeInQuad(x,(t*2)-d, b+c/2, c/2, d);
	},


	easeInCubic: function (x, t, b, c, d) {
		return c*(t/=d)*t*t + b;
	},
	easeOutCubic: function (x, t, b, c, d) {
		return c*((t=t/d-1)*t*t + 1) + b;
	},
	easeInOutCubic: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return c/2*t*t*t + b;
		return c/2*((t-=2)*t*t + 2) + b;
	},
	easeOutInCubic: function (x, t, b, c, d) {
		if (t < d/2) return Easing.easeOutCubic(x,t*2, b, c/2, d);
		return Easing.easeInCubic(x,(t*2)-d, b+c/2, c/2, d);
	},


	easeInQuart: function (x, t, b, c, d) {
		return c*(t/=d)*t*t*t + b;
	},
	easeOutQuart: function (x, t, b, c, d) {
		return -c * ((t=t/d-1)*t*t*t - 1) + b;
	},
	easeInOutQuart: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return c/2*t*t*t*t + b;
		return -c/2 * ((t-=2)*t*t*t - 2) + b;
	},
	easeOutInQuart: function (x, t, b, c, d) {
		if (t < d/2) return Easing.easeOutQuart(x,t*2, b, c/2, d);
		return Easing.easeInQuart(x,(t*2)-d, b+c/2, c/2, d);
	},


	easeInQuint: function (x, t, b, c, d) {
		return c*(t/=d)*t*t*t*t + b;
	},
	easeOutQuint: function (x, t, b, c, d) {
		return c*((t=t/d-1)*t*t*t*t + 1) + b;
	},
	easeInOutQuint: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return c/2*t*t*t*t*t + b;
		return c/2*((t-=2)*t*t*t*t + 2) + b;
	},
	easeOutInQuint: function (x, t, b, c, d) {
		if (t < d/2) return Easing.easeOutQuint(x,t*2, b, c/2, d);
		return Easing.easeInQuint(x,(t*2)-d, b+c/2, c/2, d);
	},


	easeInSine: function (x, t, b, c, d) {
		return -c * Math.cos(t/d * (Math.PI/2)) + c + b;
	},
	easeOutSine: function (x, t, b, c, d) {
		return c * Math.sin(t/d * (Math.PI/2)) + b;
	},
	easeInOutSine: function (x, t, b, c, d) {
		return -c/2 * (Math.cos(Math.PI*t/d) - 1) + b;
	},
	easeOutInSine: function (x, t, b, c, d) {
		if (t < d/2) return Easing.easeOutSine(x,t*2, b, c/2, d);
		return Easing.easeInSine(x,(t*2)-d, b+c/2, c/2, d);
	},


	easeInExpo: function (x, t, b, c, d) {
		return (t==0) ? b : c * Math.pow(2, 10 * (t/d - 1)) + b;
	},
	easeOutExpo: function (x, t, b, c, d) {
		return (t==d) ? b+c : c * (-Math.pow(2, -10 * t/d) + 1) + b;
	},
	easeInOutExpo: function (x, t, b, c, d) {
		if (t==0) return b;
		if (t==d) return b+c;
		if ((t/=d/2) < 1) return c/2 * Math.pow(2, 10 * (t - 1)) + b;
		return c/2 * (-Math.pow(2, -10 * --t) + 2) + b;
	},
	easeOutInExpo: function (x, t, b, c, d) {
		if (t < d/2) return Easing.easeOutExpo(x,t*2, b, c/2, d);
		return Easing.easeInExpo(x,(t*2)-d, b+c/2, c/2, d);
	},


	easeInCirc: function (x, t, b, c, d) {
		return -c * (Math.sqrt(1 - (t/=d)*t) - 1) + b;
	},
	easeOutCirc: function (x, t, b, c, d) {
		return c * Math.sqrt(1 - (t=t/d-1)*t) + b;
	},
	easeInOutCirc: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return -c/2 * (Math.sqrt(1 - t*t) - 1) + b;
		return c/2 * (Math.sqrt(1 - (t-=2)*t) + 1) + b;
	},
	easeOutInCirc: function (x, t, b, c, d) {
		if (t < d/2) return Easing.easeOutCirc(x,t*2, b, c/2, d);
		return Easing.easeInCirc(x,(t*2)-d, b+c/2, c/2, d);
	},


	easeInElastic: function (x, t, b, c, d) {
		var s=1.70158;var p=0;var a=c;
		if (t==0) return b;  if ((t/=d)==1) return b+c;  if (!p) p=d*.3;
		if (a < Math.abs(c)) { a=c; var s=p/4; }
		else var s = p/(2*Math.PI) * Math.asin (c/a);
		return -(a*Math.pow(2,10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )) + b;
	},
	easeOutElastic: function (x, t, b, c, d) {
		var s=1.70158;var p=0;var a=c;
		if (t==0) return b;  if ((t/=d)==1) return b+c;  if (!p) p=d*.3;
		if (a < Math.abs(c)) { a=c; var s=p/4; }
		else var s = p/(2*Math.PI) * Math.asin (c/a);
		return a*Math.pow(2,-10*t) * Math.sin( (t*d-s)*(2*Math.PI)/p ) + c + b;
	},
	easeInOutElastic: function (x, t, b, c, d) {
		var s=1.70158;var p=0;var a=c;
		if (t==0) return b;  if ((t/=d/2)==2) return b+c;  if (!p) p=d*(.3*1.5);
		if (a < Math.abs(c)) { a=c; var s=p/4; }
		else var s = p/(2*Math.PI) * Math.asin (c/a);
		if (t < 1) return -.5*(a*Math.pow(2,10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )) + b;
		return a*Math.pow(2,-10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )*.5 + c + b;
	},


	easeInBack: function (x, t, b, c, d, s) {
		if (s == undefined) s = 1.70158;
		return c*(t/=d)*t*((s+1)*t - s) + b;
	},
	easeOutBack: function (x, t, b, c, d, s) {
		if (s == undefined) s = 1.70158;
		return c*((t=t/d-1)*t*((s+1)*t + s) + 1) + b;
	},
	easeInOutBack: function (x, t, b, c, d, s) {
		if (s == undefined) s = 1.70158; 
		if ((t/=d/2) < 1) return c/2*(t*t*(((s*=(1.525))+1)*t - s)) + b;
		return c/2*((t-=2)*t*(((s*=(1.525))+1)*t + s) + 2) + b;
	},


	easeInBounce: function (x, t, b, c, d) {
		return c - Tween.ease.easeOutBounce(x, d-t, 0, c, d) + b;
	},
	easeOutBounce: function (x, t, b, c, d) {
		if ((t/=d) < (1/2.75)) {
			return c*(7.5625*t*t) + b;
		} else if (t < (2/2.75)) {
			return c*(7.5625*(t-=(1.5/2.75))*t + .75) + b;
		} else if (t < (2.5/2.75)) {
			return c*(7.5625*(t-=(2.25/2.75))*t + .9375) + b;
		} else {
			return c*(7.5625*(t-=(2.625/2.75))*t + .984375) + b;
		}
	},
	easeInOutBounce: function (x, t, b, c, d) {
		if (t < d/2) return Tween.ease.easeInBounce(x, t*2, 0, c, d) * .5 + b;
		return Tween.ease.easeOutBounce(x, t*2-d, 0, c, d) * .5 + c*.5 + b;
	}
}


//------------------------------------------------------------------------------------------------------------------------------

} )( ) ;
